import React, { useMemo, useRef } from 'react';
import useBindToContext from 'hooks/useBindToContext';
import ReactQuill from 'react-quill';
import uuid from 'uuid/v1';
import { GOOGLE_FONTS } from 'lib/globals';
import 'react-quill/dist/quill.snow.css';
import classNames from 'lib/classNames';
import { API } from 'aws-amplify';

const getColors = (value) => {
	const array = [];
	if (value === null || value === undefined) return [];
	if (typeof value === 'string' && new RegExp('^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$').test(value)) array.push(value);
	else if (typeof value === 'object') {
		Object.entries(value).forEach(([key, v]) => {
			array.push(getColors(value[key]));
		});
	}
	return array;
};

const RichEditor = ({
	BindToContext,
	value,
	onChange,
	specificValidation = null,
	getError = null,
	validation = null,
	disabled = false,
	onFocus = null,
	onBlur = null,
	placeholder = undefined,
	imageEmoji = false,
	rtl = false,
	debug = false,
	indicator
}) => {
	const id = uuid();
	const editorRef = useRef(null);
	const colors = BindToContext ? [...new Set(getColors(BindToContext[0].state).flat(Infinity))] : [];
	const [BindedValue, BindedOnChange, _hasError, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation,
		debug
	);
	const input = document.createElement("input");
	input.setAttribute("type", "file");
	input.setAttribute("accept", "image/*");
	input.onchange = async () => {
		const file = input.files[0];
		if (/^image\//.test(file?.type)) {
			try {
				const reader = new FileReader();
				reader.readAsDataURL(file)
				reader.onload = async (event) => {
					const attachment = event.target.result
					const fileName = file.name
					const response = await API.post("API_GATEWAY_NEW", "/uploadImage", {
						body: { fileName, attachment }
					});
					const editor = editorRef.current.getEditor();
					editor.insertEmbed(editor.getSelection(), "image", response.public_url);
				}
			} catch (error) {
				console.log(error.message);
			}
		} else {
			console.log('You could only upload images.');
		}
	};

	const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [{ align: [] }],
        //   [{ color: colors }],
		  [{ color: ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-color'] }],
          ["image", "direction"],
          ["link"],
        ],
        handlers: {
          image: async () => {
            console.log("working");
            input.click();
            return true;
          },
          color: function (value) {
            if (value == "custom-color")
              value = window.prompt("Enter Hex Color Code");
            this.quill.format("color", value);
          },
        },
      },
    }),
    []
  );

	return (
		<div>
			<ReactQuill
				id={id}
				className={classNames('bg-white', {
					'emoji-image': imageEmoji,
				})}
				ref={editorRef}
				theme="snow"
				disabled={disabled}
				value={BindedValue}
				placeholder={placeholder}
				onChange={(value) => BindedOnChange(value)}
				onFocus={() => {
					if (onFocus) onFocus();
				}}
				onBlur={() => {
					if (onBlur) {
						const editor = document.getElementById(id);
						const activeElement = document.activeElement;
						onBlur(editor, activeElement);
					}
				}}
				modules={modules}
			/>
			{
				indicator && <p className={classNames("text-gray-500 text-xs italic")}>{indicator}</p>
			}
		</div>
	);
};

export default RichEditor;
